module.exports = {
      id: "twitter-icon-usage",
      viewBox: "0 0 135.08 135.08",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#twitter-icon",
      toString: function () {
        return this.url;
      }
    }